#!/usr/bin/env node

import { LLMail } from '../LLMail.js';
import yargs from 'yargs';
import { hideBin } from 'yargs/helpers';
import { realFileSystemAdapter } from '../utils/file-system-adapter.js';
import { loadLlmailConfig } from '../utils/config.js';
import { logger } from '../utils/logger.js';

async function main() {
  const argv = yargs(hideBin(process.argv))
    .usage('Usage: $0 <id> [options]')
    .option('state', {
      alias: 's',
      type: 'string',
      description: 'New state for the item',
    })
    .option('type', {
      alias: 't',
      type: 'string',
      description: 'New type for the item',
    })
    .option('active', {
      type: 'boolean',
      description: 'Set as active',
    })
    .option('inactive', {
      type: 'boolean',
      description: 'Set as inactive',
    })
    .demandCommand(1, 'You must provide the id of the item to move')
    .help()
    .parseSync();

  // Get the positional argument 'id'
  const id = argv._[0] as string;

  // Build options object for llmail.move()
  const options: any = {};
  if (argv.state) {
    options.state = argv.state;
  }
  if (argv.type) {
    options.type = argv.type;
  }
  if (argv.active !== undefined) {
    options.active = argv.active;
  }
  if (argv.inactive !== undefined) {
    options.inactive = argv.inactive;
  }

  const fsAdapter = realFileSystemAdapter;
  const rootDir = process.cwd();
  const configPath = argv.config as string | undefined;

  try {
    const config = await loadLlmailConfig(fsAdapter, rootDir, configPath);
    const llmail = new LLMail({ fs: fsAdapter, config });
    await llmail.init();

    await llmail.mv(id, options);
    logger.success(`Item ${id} moved successfully.`);
  } catch (error) {
    console.error('Error moving item:', error);
    process.exit(1);
  }
}

main(); 